module.exports = __webpack_public_path__ + "img/zhanli11.a52af77b.jpg";